<template>
<v-simple-table flat>
<template v-slot:default>
<thead>
<tr>
<th v-for="head in headers" :key="head" class="text-left">
	{{ mwTranslate('results', head) }}
</th>
</tr>
</thead>
<tbody>
<tr
v-for="item in rows"
:key="item.series"
>
<!-- <td>{{ item.series }}</td> -->
<td v-for="head in headers" :key="head" class="text-left">
	{{item[head]}}
</td>
</tr>
</tbody>
</template>
</v-simple-table>

</template>

<style lang="less">
	
</style>

<script type="text/javascript">
	// import Vuex from "vuex";
	// import - from "@/components/"
	export default {
		name: "ChartTable", 
		props: {
			headers: {type: Array},
			rows: {type: Array}	
		},
		data: () => {
			return {

			}
		},
		// components: {

		// },
		// computed: {
			// ...Vuex.mapState({})
		// },
		// methods: {
		// }
		// created(){
			
		// }

	}
</script>